import G6, { TreeGraph } from '@antv/g6/dist/g6.min';
import { generateActionBar } from './common';
import { CustomNodeType } from './config';

export const registerPolicyShapes = (treeGraph: TreeGraph) => {
  G6.registerNode(CustomNodeType.POLICY, {
    draw: (cfg, group) => {
      return group!.addShape('dom', {
        attrs: {
          width: cfg!.size![0],
          height: cfg!.size![1],
          // 传入 DOM 的 html
          html: `
          <div style="height: 100%;">
            <div style="background-color: ${
              cfg!.style!.titleBgColor
            };border-radius:4px;color: #fff;text-align: center;height: 36px;line-height: 36px;">
            ${(cfg!.jsonData as any).name}
            </div>
            ${generateActionBar(cfg)}
          </div>
          `
        }
      });
    }
  });
};
